import React from "react";
import {
  FacebookShareButton, FacebookIcon,
  WhatsappShareButton, WhatsappIcon,
  LinkedinShareButton, LinkedinIcon,
  EmailShareButton, EmailIcon,
  TwitterShareButton, TwitterIcon
} from "react-share";

export default function SocialMediaButtons(props) {

  const url = "https://www.niddaa.com";

  const copyAndNotify = async () => {
    try {
      await navigator.clipboard.writeText(`${url}\n${props.msg_share}`);
      alert("Copied! You can now paste it on Instagram or Snapchat.");
    } catch (err) {
      alert("Copy failed. Please copy manually.");
    }
  };

  return (
    <>
      {/* Facebook */}
      <div className="share-col-icon">
        <FacebookShareButton url={url} quote={props.msg_share} hashtag="#camperstribe">
          <FacebookIcon size={36} />
        </FacebookShareButton>
      </div>

      {/* WhatsApp */}
      <div className="share-col-icon">
        <WhatsappShareButton url={url} title={props.msg_share}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>

      {/* LinkedIn */}
      <div className="share-col-icon">
        <LinkedinShareButton url={url} title={props.msg_share}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </div>

      {/* Email */}
      <div className="share-col-icon">
        <EmailShareButton url={url} title={props.msg_share}>
          <EmailIcon size={32} round />
        </EmailShareButton>
      </div>

      {/* Twitter */}
      <div className="share-col-icon">
        <TwitterShareButton url={url} title={props.msg_share}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </div>

      {/* Instagram (copy method) */}
      <div className="share-col-icon">
        <button onClick={copyAndNotify} style={{ background: "none", border: "none" }}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
            alt="Instagram"
            width="32"
            height="32"
          />
        </button>
      </div>

      {/* Snapchat (copy method) */}
      <div className="share-col-icon">
        <button onClick={copyAndNotify} style={{ background: "none", border: "none" }}>
          <img
            src="https://cdn-icons-png.flaticon.com/512/733/733621.png"
            alt="Snapchat"
            width="32"
            height="32"
          />
        </button>
      </div>
    </>
  );
}